import React from "react";
import { Component } from "preact";
import styles from "./Dropdown.scss";

const arrowIcon = require("../../assets/ic_dropdown.svg");
const snaggleTooth = require("../../assets/ic_rectangle_dropdown_white.svg");

class Dropdown extends Component {
  constructor(props) {
    super(props);
    this.startTimeout = this.startTimeout.bind(this);
    this.cancelTimeout = this.cancelTimeout.bind(this);
  }

  startTimeout() {
    let { open, openToggle } = this.props;
    if (open) {
      this.timeout = setTimeout(() => {
        openToggle();
      }, 400);
    }
  }

  cancelTimeout() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }

  render() {
    let { title, open, openToggle, children, hasDone } = this.props;
    return (
      <div
        style={{ position: "relative", display: "inline-block" }}
        onMouseLeave={this.startTimeout}
      >
        <button
          className={styles.mainButton}
          onClick={openToggle}
          aria-expanded={open ? "true" : "false"}
        >
          <h3 className={styles.title}>{title}</h3>{" "}
          <img
            src={arrowIcon}
            className={styles.icon}
            style={{ transform: `rotateZ(${open ? -180 : 0}deg)` }}
            alt=""
          />
        </button>
        {open ? (
          <div
            className={styles.dropdownBody}
            onMouseEnter={this.cancelTimeout}
          >
            <img src={snaggleTooth} className={styles.snaggleTooth} alt="" />
            {children}
            {hasDone ? (
              <button
                className={styles.doneButton}
                onClick={openToggle}
                aria-label="Done"
              >
                Done
              </button>
            ) : null}
          </div>
        ) : (
          <div />
        )}
      </div>
    );
  }
}

export default Dropdown;
